import React, { useState, useEffect } from 'react';
import Navbar from '../navbar/Navbar';
import { Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import ThreeDTicTacToe from '../../components/threedcube/ThreeDTicTacToe';
import { ClockCircleFilled, FrownFilled, TrophyFilled } from '@ant-design/icons';
import "./styles.css";

export default function Game() {
  const [history, setHistory] = useState([Array(6).fill(null).map(() => Array(9).fill(null))]);
  const [currentMove, setCurrentMove] = useState(0);
  const [isBotPlaying, setIsBotPlaying] = useState(false);
  const [winner, setWinner] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const xIsNext = currentMove % 2 === 0;

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    setUser(currentUser);
    if (currentUser == null) {
      navigate('/');
      window.location.reload();
    }
  }, [localStorage.getItem('currentUser')]);

  useEffect(() => {
    if (!xIsNext && !isBotPlaying && !winner) {
      setIsBotPlaying(true);
      setTimeout(() => {
        const faceIndex = Math.floor(Math.random() * 6);
        const botMoveIndex = calculateBotMove(history[currentMove][faceIndex]);
        handlePlay(
          history[currentMove].map((faceSquares, idx) =>
            idx === faceIndex
              ? faceSquares.map((square, i) => (i === botMoveIndex ? 'O' : square))
              : faceSquares
          )
        );
        setIsBotPlaying(false);
      }, 1000);
    }
  }, [xIsNext, isBotPlaying, history, currentMove, winner]);

  function handlePlay(nextSquares) {
    const faceWinner = nextSquares.flatMap(face => calculateWinner(face)).find(Boolean);
    if (faceWinner) {
      setWinner(faceWinner);
      updateUserInfo(faceWinner);
    } else if (nextSquares.every(face => face.every(Boolean))) {
      setWinner('Draw');
      updateUserInfo(null);
    }
    const nextHistory = [...history.slice(0, currentMove + 1), nextSquares];
    setHistory(nextHistory);
    setCurrentMove(nextHistory.length - 1);
  }

  function jumpTo(nextMove) {
    setCurrentMove(nextMove);
    setWinner(null);
  }

  const moves = history.map((step, move) => {
    const description = move ? `Go to move #${move}` : 'Go to game start';
    return (
      <li key={move}>
        <button onClick={() => jumpTo(move)}>{description}</button>
      </li>
    );
  });

  return (
    <div>
      <Navbar />
      <div className="game">
        <div style={{ flexDirection: 'row', display: 'flex' }}>
          <div className="game-board">
            <Card className="board-status-card">
              <div className="status">
                <div>
                  {!winner ?
                    <ClockCircleFilled style={{ fontSize: '32px' }} /> :
                    (winner === 'X' ?
                      <TrophyFilled style={{ fontSize: '32px' }} /> :
                      <FrownFilled style={{ fontSize: '32px' }} />
                    )
                  }
                </div>
                <div style={{ paddingLeft: '5%', fontWeight: 'bold' }}>
                  {winner ? `Winner: ${winner == "X"?user?.username:"Bot"}` : `Next player: ${xIsNext ? user?.username : 'Bot'}`}
                </div>
              </div>
            </Card>
            <Card className="board-square-card" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', marginTop: '5%' }}>
              <ThreeDTicTacToe history={history} handlePlay={handlePlay} currentMove={currentMove} isBotPlaying={isBotPlaying} gameEnded={!!winner} />
            </Card>
          </div>
          <Card style={{ marginLeft: '5%', width: '15vw', paddingTop: 0, backgroundColor: "#5F374B", color: 'white' }}>
            <div className='user-info'>
              <p style={{ lineHeight: 0.4 }}>Player: {user?.username}</p>
              <p style={{ lineHeight: 0.4 }}>Wins: {user?.win}</p>
              <p style={{ lineHeight: 0.4 }}>Defeats: {user?.lose}</p>
              <p style={{ lineHeight: 0.4 }}>Total games: {user?.totalgame}</p>
              <p style={{ lineHeight: 0.4 }}>Scores: {user?.score}</p>
            </div>
            <div className="game-info">
              <p style={{ fontWeight: 'bold', display: 'inline', lineHeight: 0, margin: 0 }}>Moves history</p>
              <ol style={{ listStyle: 'none', alignSelf: 'center', alignContent: 'center', padding: 0, maxHeight: '100%' }}>{moves}</ol>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}

function updateUserInfo(winner) {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  const tempUsers = JSON.parse(localStorage.getItem('users'));

  if (winner === 'X') {
    currentUser.win += 1;
    currentUser.score += 1;
  } else if (winner === 'O') {
    currentUser.lose += 1;
    currentUser.score -= 1;
  } else {
    currentUser.draw += 1;
  }

  currentUser.totalgame += 1;
  localStorage.setItem('currentUser', JSON.stringify(currentUser));
  for (let i = 0; i < tempUsers.length; i++) {
    if (tempUsers[i].username === currentUser.username) {
      tempUsers[i] = currentUser;
    }
  }
  localStorage.setItem('users', JSON.stringify(tempUsers));
}

function calculateBotMove(squares) {
  const emptySquares = squares.map((square, index) => square === null ? index : null).filter(val => val !== null);
  return emptySquares[Math.floor(Math.random() * emptySquares.length)];
}
